import type { FC } from 'react';
import React from 'react';
import { styled } from '@this/constants/themes';
import { observer } from 'mobx-react';
import Box from '@material-ui/core/Box';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import muiTheme from '@this/components/appoint/mui_theme';

interface Props {
  clearTitle: string;
  onClear?: () => void;
}

const HoverActionBox: FC<Props> = observer(({ children, clearTitle, onClear }) => {
  return (
    <TheBox display="flex">
      <Box style={{ marginRight: 'auto' }}>{children}</Box>
      <Tooltip title={clearTitle}>
        <DeleteButton size="small" onClick={() => onClear && onClear()}>
          <CloseIcon fontSize="small" style={{ color: '#fff' }} />
        </DeleteButton>
      </Tooltip>
    </TheBox>
  );
});

const TheBox = styled(Box)`
  display: flex;
  align-items: center;
  margin: 8px 0;
  padding: 10px 12px;
  color: ${muiTheme.palette.primary.main};
  border: solid 1px;
  border-radius: 3px;
  p {
    font-size: 12px;
  }
`;

const DeleteButton = styled(IconButton)`
  height: 15px;
  margin: -1px 0 0 8px;
  padding: 2px;
  background-color: ${muiTheme.palette.primary.main};
  color: ${muiTheme.palette.primary.light};

  .MuiSvgIcon-fontSizeSmall {
    height: 11px;
    font-size: 11px;
    line-height: 1;
  }
`;

export default HoverActionBox;
